import { connect } from 'react-redux';
import styles from './ImpersonationBar.module.css';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    ...state.siteContext,
    showImpersonationBar: state.siteContext.impersonating
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

function ImpersonationBar({
    showImpersonationBar,
    impersonatingStateKey,
    errorCode,
    errorDetail
}: PropsFromRedux) {
    function renderErrors() {
        if (errorCode) {
            return (
                <div>
                    <small>
                        <strong>{errorCode}</strong> {errorDetail}
                    </small>
                </div>
            );
        }
    }

    if (showImpersonationBar) {
        return (
            <div className={styles.ImpersonationBar}>
                Impersonating state key:{' '}
                <strong>{impersonatingStateKey}</strong>
                {renderErrors()}
            </div>
        );
    } else {
        return null;
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ImpersonationBar);
